// The code in this file will load on every page of your site

$w.onReady(function () {
	// Write your code here
});

$w('#header1').onClick((event) => {
        
})